import { RARITY_API_REF } from 'types/modifiers/references';

const RARITY_GEM_PNG_PATH = {
  [RARITY_API_REF.COMMON]: '/cards/rarity/common.png',
  [RARITY_API_REF.RARE]: '/cards/rarity/rare.png',
  [RARITY_API_REF.UNIQUE]: '/cards/rarity/unique.png',
};

export const RARITY_GEM_MAP = {
  [RARITY_API_REF.COMMON]: <img alt="" src={RARITY_GEM_PNG_PATH.COMMON} width={40} />,
  [RARITY_API_REF.RARE]: <img alt="" src={RARITY_GEM_PNG_PATH.RARE} width={40} />,
  [RARITY_API_REF.UNIQUE]: <img alt="" src={RARITY_GEM_PNG_PATH.UNIQUE} width={40} />,
};

export const RARITY_ICON_PNG_PATH_MAP = {
  [RARITY_API_REF.COMMON]: '/common.png',
  [RARITY_API_REF.RARE]: '/rare.png',
  [RARITY_API_REF.UNIQUE]: '/unique.png',
};

export const RARITY_ICON_PNG_MAP = {
  [RARITY_API_REF.COMMON]: <img alt="" src={RARITY_ICON_PNG_PATH_MAP.COMMON} />,
  [RARITY_API_REF.RARE]: <img alt="" src={RARITY_ICON_PNG_PATH_MAP.RARE} />,
  [RARITY_API_REF.UNIQUE]: <img alt="" src={RARITY_ICON_PNG_PATH_MAP.UNIQUE} />,
};
